import * as React from "react";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import { IdNamePair } from "../../model/autogen/IdNamePair";
import PeopleLookup from "../people-lookup";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";

export interface IPeopleLookupDialogProps {
    isPickingPerson: boolean;
    personLabel: string;

    onPersonSelected: (person: IdNamePair) => void;
    onCancelPickingPerson: (e: any) => void;
}

export const PeopleLookupDialog = (props: IPeopleLookupDialogProps) => {
    const { isPickingPerson, personLabel, onPersonSelected, onCancelPickingPerson } = props;
    return <Dialog open={isPickingPerson}>
    <DialogTitle id="responsive-dialog-title">Select {personLabel}</DialogTitle>
    <DialogContent>
        <DialogContentText>
            Search for the specific {personLabel} below
        </DialogContentText>
        <PeopleLookup onPersonSelected={onPersonSelected} />
    </DialogContent>
    <DialogActions>
        <Button onClick={onCancelPickingPerson} color="secondary">
            Cancel
        </Button>
    </DialogActions>
</Dialog>
}


// WEBPACK FOOTER //
// ./src/components/forms/people-lookup-dialog.tsx